import { legacy_createStore as createStore, applyMiddleware, compose } from 'redux';
import { rememberEnhancer } from 'redux-remember';
import { rootReducer, rememberedKeys } from './rootReducer';

// Create the Redux store
const store = createStore(
    rootReducer,
    compose(
        applyMiddleware(),
        // Remember only the specified reducers in localStorage
        rememberEnhancer(
            window.localStorage, // Using localStorage to persist state
            rememberedKeys
        )
    )
);

export default store;